<template>
  <transition name="from-top">
    <div v-if="hasErrors" class="tol-errors">
      <TolAlert
        :message="errorMessage"
        :items="errorItems"
        :dismissable="true"
        type="error"
        @dismiss="onDismiss"
      />
    </div>
  </transition>
</template>

<script>
import TolAlert from '@/app/components/TolAlert';
import { TolErrorsActions, TolErrorsGetters } from '@/app/features/tol-errors/tol-errors.keys';
import { isEmpty } from 'ramda';

const MAX_ITEMS_DISPLAY = 5;

/**
 * Log raw/unprocessed error state variables to console for development only
 */
function logErrors() {
  if (process.env.NODE_ENV !== 'production') {
    if (!isEmpty(this.$store.getters[TolErrorsGetters.Message])) {
      console.error('TOL ERROR MESSAGE:', this.$store.getters[TolErrorsGetters.Message]);
    }
    if (!isEmpty(this.$store.getters[TolErrorsGetters.ErrorObject])) {
      console.error('TOL ERROR OBJECT:', this.$store.getters[TolErrorsGetters.ErrorObject]);
    }
    if (!isEmpty(this.$store.getters[TolErrorsGetters.Items])) {
      console.error('TOL ERROR ITEMS:', this.$store.getters[TolErrorsGetters.Items]);
    }
  }
}

export default {
  name: 'TolErrors',
  components: {
    TolAlert
  },
  computed: {
    errorItems() {
      let items = this.$store.getters[TolErrorsGetters.Items];

      if (items.length > MAX_ITEMS_DISPLAY) {
        let count = items.length - MAX_ITEMS_DISPLAY + 1;
        items = items.slice(0, MAX_ITEMS_DISPLAY - 1);
        items.push(this.$tc('components.tolErrors.moreItems', count, { count }));
      }

      return items;
    },
    errorMessage() {
      const count = this.errorItems.length;
      const msg = this.$store.getters[TolErrorsGetters.Message];
      return msg ? msg : this.$tc('components.tolErrors.defaults.message', count, { count });
    },
    hasErrors() {
      return this.$store.getters[TolErrorsGetters.HasErrors];
    }
  },
  created: logErrors,
  updated: logErrors,
  methods: {
    onDismiss() {
      this.$store.dispatch(TolErrorsActions.ClearAll);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../styles/variables.scss';

.tol-errors {
  margin-top: -$alert-vertical-margin;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
}

.from-top-enter,
.from-top-leave-to {
  opacity: 0;
  top: -30px;
}
.from-top-enter-to,
.from-top-leave {
  opacity: 1;
  top: 0;
}
.from-top-enter-active,
.from-top-leave-active {
  transition: opacity 250ms, top 250ms;
}
</style>
